import {Smartphone} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const SmartphoneIcon = createLucideIcon(Smartphone, 'SmartphoneIcon');
